import { useEffect, useState } from 'react';
// import eventBus from '../common/EventBus';
import Card, { CardItem } from '../common/Card/Card';
import { CardBody } from '../common/Card/CardBody';
import { ArticleType, newsSlider } from '../helpers/interfaces/news';
import { apiGet } from '../services/Api';
import Advertising from '../common/Advertising';

export default function Sidebar() {
  const [lastArticles, setLastArticles] = useState<Array<CardItem>>([]);
  const [mostReadArticles, setMostReadArticles] = useState<Array<CardItem>>([]);

  useEffect(() => {
    // eventBus.dispatch("showLoader", {text: "Caricamento dei dati in corso..."});

    (async() => {
      await apiGet<newsSlider, any>('?op=newsSlider&limitArt=10').then((response: newsSlider) => {
        let lastArticles: CardItem[] = [];

        response.sliderNews.forEach((news) => {
          lastArticles.push({
            id: news.id,
            content: news.titolo,
            link: '/articolo/' + news.id,
            linkTitle: 'Leggi la notizia'
          })
        });

        setLastArticles(lastArticles);
      });

      await apiGet<ArticleType[], any>('?op=listaArticoliPiuLetti&limitArt=5').then((response: ArticleType[]) => {
        let mostReadArticles: CardItem[] = [];

        response.forEach((news) => {
          mostReadArticles.push({
            id: news.id,
            image: news.img1,
            content: news.titolo,
            link: '/articolo/' + news.id,
            linkTitle: 'Leggi la notizia'
          })
        });

        setMostReadArticles(mostReadArticles);
      });

      // eventBus.dispatch("hideLoader", {});
    })();
  }, []);

  return (
    <>
      <div id="last-news" className="py-4">
        <h4>Ultime novità</h4>
        <div id="last-news-container">
          <Card id="last-news" cards={lastArticles} cardBody={CardBody} />
        </div>
      </div>
      <Advertising
        code="banner-side1"
        as="div"
        className='text-center py-4'
      />
      <div id="most-read-news" className="pt-4">
        <h4>I più letti della settimana</h4>
        <Card id="most-read-news" cards={mostReadArticles} cardBody={CardBody} />
      </div>
      <Advertising
        code="banner-side2"
        as="div"
        className='text-center py-4'
      />
    </>
  );
}
